import gql from 'graphql-tag';

export const DELETE_PLACE_MUTATION = gql`
  mutation DeletePlace($id: ID!) {
    deletePlace(id: $id) {
      place {
        id
      }
    }
  }
`;
